<script setup lang="ts">
import { HeaderNav } from '../navigation';
import MrbilitIcon from './MrbilitIcon.vue';
import AirplaneTicketIcon from './AirplaneTicketIcon.vue';

const { color = 'white' } = defineProps<IProps>();
interface IProps {
    color?: 'white' | 'blue';
    compact?: boolean;
}
const { isAirplaneTicket } = useWhiteLabel();
const siteMenuColor = computed(() =>
    color === 'white' ? 'white' : 'var(--blue-500)'
);
</script>

<template>
    <nav class="header-wrapper container">
        <h2 class="fake-title" />
        <AirplaneTicketIcon
            v-if="isAirplaneTicket"
            class="mrbilit-icon-header"
            :color
        />
        <MrbilitIcon v-else class="mrbilit-icon-header" :color />
        <HeaderNav :color="siteMenuColor" :compact />
    </nav>
</template>

<style scoped lang="scss">
.header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: auto;
    position: relative;
    z-index: 100000;

    .fake-title {
        display: none !important;
    }
}
</style>
